module.exports = __webpack_public_path__ + "img/tires.dae1fb31.png";